import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ED0006",
      "fill-rule": "evenodd",
      d: "M10.193 10.816a6.183 6.183 0 0 1-4.01 1.467C2.767 12.283 0 9.533 0 6.142 0 2.75 2.768 0 6.182 0c1.53 0 2.931.552 4.01 1.467A6.182 6.182 0 0 1 14.203 0c3.415 0 6.183 2.75 6.183 6.142 0 3.392-2.768 6.141-6.182 6.141-1.53 0-2.93-.552-4.01-1.467Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F9A000",
      "fill-rule": "evenodd",
      d: "M10.193 10.816a6.112 6.112 0 0 0 2.172-4.674 6.112 6.112 0 0 0-2.172-4.675A6.182 6.182 0 0 1 14.203 0c3.414 0 6.182 2.75 6.182 6.142 0 3.392-2.768 6.141-6.182 6.141-1.53 0-2.93-.552-4.01-1.467Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF5E00",
      "fill-rule": "evenodd",
      d: "M10.193 10.816a6.112 6.112 0 0 0 2.172-4.675 6.112 6.112 0 0 0-2.172-4.674A6.112 6.112 0 0 0 8.02 6.14c0 1.872.843 3.548 2.173 4.675Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "mastercard"}) } }